import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
// import { Navbar } from "./components/Navbar";

import Navbar from "./components/Navbar";
import Home from "./components/Home";
import PageOne from "./components/PageOne";
import PageTwo from "./components/PageTwo";
import SubPage1 from "./components/subpages/SubPage1";
import SubPage2 from "./components/subpages/SubPage2";
import SubPage3 from "./components/subpages/SubPage3";
import SubPage4 from "./components/subpages/SubPage4";
import SubPage5 from "./components/subpages/SubPage5";
import SubPage6 from "./components/subpages/SubPage6";
import SubPage7 from "./components/subpages/SubPage7";
import SubPage8 from "./components/subpages/SubPage8";
import "./App.css";
import Footer from "./components/Footer";
import Enquiries from "./components/Enquiries";
import CostEstimator from "./components/CostEstimator";




function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/page1" element={<PageOne />} />
        <Route path="/page2" element={<PageTwo />} />
        <Route path="/enquiries" element={<Enquiries />}/>
        <Route path="/page1/sub1" element={<SubPage1 />} />
        <Route path="/page1/sub2" element={<SubPage2 />} />
        <Route path="/page1/sub3" element={<SubPage3 />} />
        <Route path="/page1/sub4" element={<SubPage4 />} />
        <Route path="/page2/sub5" element={<SubPage5 />} />
        <Route path="/page2/sub6" element={<SubPage6 />} />
        <Route path="/page2/sub7" element={<SubPage7 />} />
        <Route path="/page2/sub8" element={<SubPage8 />} />
        <Route path="/estimator" element={<CostEstimator />} />

      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
